<template>
	<div id="root">
		<div class="pc" v-if="platform==='pc'">
			<div class="container--pc" :class="checkIndex==0?'multi--pc':'multi--pc-none'" style="width: 100vw;">
				<div class="container--Lascy dark--pc">
					<a class="logo--pc dark--pc" href="/"></a>
					<div class="tabs--pc">
						<div @click="check(index)" v-for="(item,index) in title" :key="index"
							class="link--pc dark--pc active--3mxta">
							<div class="link">{{item}}</div>
							<div :class="index==checkIndex?'line-active':'line'"></div>
						</div>
					</div>
				</div>
				<div class="title--1" v-if="checkIndex==0">皮皮工具箱</div>
				<div class="downloads--pc downloads--index" v-if="checkIndex==0">
					<a v-for="(item,index) in downloads" :key="index" class="downloadButton--pc"
						href="javascript:volid(0);" @click="download(index)">
						<div class="downloadContent--pc">
							<img class="appleIcon--pc" :src="item.icon">
							<div class="downloadText--pc">{{item.name}}</div>
						</div>
					</a>
				</div>
				<div class="bg--1" v-if="checkIndex==0">
					<img src="../static/img/index-1.png" />
				</div>
				<div class="team-box" v-if="checkIndex==1">
					<div class="team-title">团队信息</div>
					<div class="team-title-en">Team Information</div>
					<div class="team-icon">
						<img src="../static/img/team-icon.png" />
					</div>
					<div class="team-list">
						<el-row :gutter="20">
							<el-col :span="8" v-for="(item,index) in teams" :key="index" style="margin-top: 10px;">
								<div class="item-info">
									<div style="margin: 0 auto; text-align: center">
										<img style="width: 250px;height: 250px" :src="item.img" />
									</div>
									<div class="position">{{item.title}}</div>
									<div class="team-line"></div>
									<div class="item-info-box">
										<div class="name">昵称：{{item.name}}</div>
										<div></div>
										<div class="skill">技术栈：{{item.skill}}</div>
										<div></div>
										<div class="chat">微信：{{item.chat}}</div>
									</div>
								</div>
							</el-col>
						</el-row>
					</div>
				</div>
			</div>
			<div class="container--3" style="width: 100vw;margin-top: 35px;">
				<div class="ct-box">
					<div class="logo-3">
						<img src="../assets/logo.png" />
						<span class="title--3">皮皮工具箱</span>
					</div>
					<div class="title--4">生活与工作的</div>
					<div class="title--5">贴心小帮手</div>
					<div class="title--6">高清壁纸/视频转换/听歌识曲/每日简报</div>
					<div class="downloads--pc downloads-bottom">
						<a v-for="(item,index) in downloads" :key="index" class="downloadButton--pc"
							href="javascript:volid(0);" @click="download(index)">
							<div class="downloadContent--pc">
								<img class="appleIcon--pc" :src="item.icon">
								<div class="downloadText--pc">{{item.name}}</div>
							</div>
						</a>
					</div>
				</div>

				<div class="ct-box">
					<img src="../static/img/back-5.png" />
				</div>
			</div>
			<div class="container--2" style="width: 100vw;">
				<div class="title--2">
					了解每日时讯，与全球皮友互嗨
				</div>
				<div class="bg--2">
					<img src="../static/img/back-2.png" />
				</div>
				<div class="bg--3">
					<img src="../static/img/back-3.png" />
				</div>
				<div class="bg--4">
					<img src="../static/img/back-4.png" style="width: 100%;" />
				</div>
			</div>
			<div class="bottom">
				<a href="javascript:void(0)" class="company">六安市皮皮网络科技有限责任公司</a>
				<a href="javascript:void(0)" class="cell">|</a>
				<a href="https://beian.miit.gov.cn" class="icp">皖ICP备2022001808号</a>
				<a href="javascript:void(0)" class="cell">|</a>
				<a href="javascript:void(0)" class="tip">隐私政策</a>
			</div>
		</div>
		<div class="h5" v-if="platform==='h5'">
			<div class="page">
				<div :class="checkIndex==0?'container--index-h5':'container--index-h5-none'"
					style="width: 100vw;min-height: 65vh;">
					<div class="container--header">
						<a class="logo--h5" href="/"></a>
						<div class="tabs--h5">
							<div @click="check(index)" v-for="(item,index) in title" :key="index"
								class="link--h5 dark--h5 active--h5">
								<div class="link-d-h5" :style="checkIndex==1?'color: #222222 !important;':''">{{item}}
								</div>
								<div :class="index==checkIndex?'line-active':'line'"
									:style="checkIndex==1?'background-color: #222222 !important;':''"></div>
							</div>
						</div>
					</div>
					<div class="title--1 title--1-h5" v-if="checkIndex==0">皮皮工具箱</div>
					<div class="downloads--h5 downloads--index-h5" v-if="checkIndex==0">
						<a v-for="(item,index) in downloads" :key="index" class="downloadButton--h5"
							href="javascript:volid(0);" @click="download(index)">
							<div class="downloadContent--pc">
								<img class="appleIcon--pc" :src="item.icon">
								<div class="downloadText--pc">{{item.name}}</div>
							</div>
						</a>
					</div>
					<div class="bg--1" style="margin-top: 20%;" v-if="checkIndex==0">
						<img style="width: 100%;height: auto;" src="../static/img/index-1.png" />
					</div>
					<div class="team-box" v-if="checkIndex==1">
						<div class="team-title" style="font-size: 24px;line-height: 24px;">团队信息</div>
						<div class="team-title-en" style="font-size: 20px;line-height: 34px;">Team Information</div>
						<div class="team-list">
							<el-row :gutter="20">
								<el-col :span="24" v-for="(item,index) in teams" :key="index" style="margin-top: 10px;">
									<div class="item-info">
										<div style="margin: 0 auto; text-align: center">
											<img style="width: 50%;height: 50%" :src="item.img" />
										</div>
										<div class="position" style="font-size: 16px;">{{item.title}}</div>
										<div class="team-line" style="margin-top: 10px;"></div>
										<div class="item-info-box"
											style="margin-top: 10px;min-height: 100px;margin-left: 0;width: 100%;">
											<div class="name">昵称：{{item.name}}</div>
											<div></div>
											<div class="skill">技术栈：{{item.skill}}</div>
											<div></div>
											<div class="chat">微信：{{item.chat}}</div>
										</div>
									</div>
								</el-col>
							</el-row>
						</div>
					</div>
				</div>
				<div class="container--3" style="width: 100vw;margin-top: 50px;">
					<div class="ct-box" style="width: 100%;">
						<div class="logo-3-h5">
							<img src="../assets/logo.png" />
							<span class="title--3 title--3-h5">皮皮工具箱</span>
						</div>
						<div class="title--4 title--4-h5">生活与工作的</div>
						<div class="title--5 title--5-h5">贴心小帮手</div>
						<div class="title--6 title--6-h5">高清壁纸/视频转换/听歌识曲/每日简报</div>
						<div class="downloads--pc downloads-bottom" style="margin-top: 0;left: 15%;">
							<a v-for="(item,index) in downloads" :key="index" class="downloadButton--pc"
								href="javascript:volid(0);" @click="download(index)">
								<div class="downloadContent--pc">
									<img class="appleIcon--pc" :src="item.icon">
									<div class="downloadText--pc">{{item.name}}</div>
								</div>
							</a>
						</div>
					</div>

					<div class="ct-box" style="width: 100%;margin-top: 50px;margin-left: 8%;">
						<img src="../static/img/back-5.png" style="width: 100%;height: auto;" />
					</div>
				</div>
				<div class="container--2-h5" style="width: 100vw;margin-top: -115px;">
					<div class="title--2-h5">
						了解每日时讯，与全球皮友互嗨
					</div>
					<div class="bg--2-h5">
						<img style="width: 100%;height: auto;" src="../static/img/back-2.png" />
					</div>
					<div class="bg--3-h5" style="position: absolute;z-index: 0;width: 100%;">
						<img style="width: 100%;height: auto;" src="../static/img/back-3.png" />
					</div>
					<div class="bg--4-h5">
						<img style="width: 100%;height: auto;" src="../static/img/back-4.png" />
					</div>
				</div>
				<div class="bottom-h5">
					<a href="javascript:void(0)" class="company">六安市皮皮网络科技有限责任公司</a>
					<a href="javascript:void(0)" class="cell-h5">|</a>
					<a href="https://beian.miit.gov.cn" class="icp">皖ICP备2022001808号</a>
					<a href="javascript:void(0)" class="cell-h5">|</a>
					<a href="javascript:void(0)" class="tip">隐私政策</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				title: ['皮皮工具箱', '团队信息'],
				checkIndex: 0,
				downloads: [{
						name: 'IOS下载',
						icon: require('../static/img/apple.png'),
						url: 'https://apps.apple.com/cn/app/皮皮工具箱/id1540607796'
					},
					{
						name: '安卓下载',
						icon: require('../static/img/android.png'),
						url: 'https://api.ppgjx.com/app/app/redirect?type=proandroiddown'
					}
				],
				platform: 'h5',
				teams: [{
						name: 'ʚɞ野猪哥哥',
						img: require('../static/img/ʚɞ野猪哥哥.jpg'),
						skill: 'WEB 设计、MUI 设计、动效设计、三维设计',
						title: 'UI设计师',
						chat: 'eighttttttt'
					}, {
						name: '刘斌',
						img: require('../static/img/刘斌.jpg'),
						skill: 'WEB开发',
						title: 'WEB开发工程师',
						chat: 'LiuBin199575'
					}, {
						name: '葬爱-刀',
						img: require('../static/img/葬爱-刀.jpg'),
						skill: 'IOS开发',
						title: 'IOS开发工程师',
						chat: 'nabapocaidao'
					}, {
						name: '彩鸢',
						img: require('../static/img/彩鸢.jpg'),
						skill: 'WEB 设计、MUI 设计、动效设计、三维设计',
						title: 'UI设计师',
						chat: 'LuckLee1112'
					}, {
						name: 'Grins',
						img: require('../static/img/Grins.jpg'),
						skill: 'android开发',
						title: 'android开发工程师',
						chat: 'mail19462'
					},
					{
						name: '123',
						img: require('../static/img/123.jpg'),
						skill: 'WEB开发',
						title: 'WEB开发工程师',
						chat: 'x2524931333'
					}
				]
			}
		},
		created() {
			if (document.documentElement.clientWidth < 1000) {
				this.platform = 'h5'
			} else {
				this.platform = 'pc'
			}
		},
		methods: {
			check(index) {
				this.checkIndex = index;
			},
			download(index) {
				const iosLinkUrl = this.downloads[0].url
				const androidLinkurl = this.downloads[1].url
				const huaweiUrl = 'appmarket://details?id=com.ppgjx'
				const oppoUrl = "oppomarket://details?packagename=com.ppgjx"
				const vivoUrl = "vivomarket://details?id=com.ppgjx"
				const xiaomiUrl = 'mimarket://details?id=com.ppgjx'
				var phone = this.judeBrand()
				if (phone === 'iphone' && index == 1) {
					window.open(androidLinkurl)
				} else {
					switch (this.judeBrand()) {
						case 'iphone':
							this.downLoadUrl(iosLinkUrl)
							break
						case 'xiaomi':
							this.downLoadUrl(xiaomiUrl)
							break
						case 'huawei':
							this.downLoadUrl(huaweiUrl)
							break
						case 'vivo':
							this.downLoadUrl(vivoUrl)
							break
						case 'oppo':
							this.downLoadUrl(oppoUrl)
							break
						default:
							this.downLoadUrl(androidLinkurl)
							break
					}
				}

			},
			downLoadUrl(url) {
				const a = document.createElement('a')
				a.href = url
				a.click()
			},
			judeBrand() {
				var MobileDetect = require('mobile-detect'),
					navigator = new MobileDetect(window.navigator.userAgent);
				const userAgent =navigator.phone().toLowerCase()
				const isIphone = userAgent.match(/(iphone|ipad|ipod)/i);
				const isHuawei = userAgent.match(/huawei/i);
				const isHonor = userAgent.match(/honor/i);
				const isOppo = userAgent.match(/oppo/i);
				const isOppoR15 = userAgent.match(/pacm00/i);
				const isVivo = userAgent.match(/vivo/i);
				const isXiaomi = userAgent.match(/mi\s/i);
				const isXIAOMI = userAgent.match(/xiaomi/i);
				const isXiaomi2s = userAgent.match(/mix\s/i);
				const isRedmi = userAgent.match(/redmi/i);

				if (isIphone) {
					return 'iphone'
				} else if (isHuawei || isHonor) {
					return 'huawei';
				} else if (isOppo || isOppoR15) {
					return 'oppo';
				} else if (isVivo) {
					return 'vivo';
				} else if (isXiaomi || isRedmi || isXiaomi2s || isXIAOMI) {
					return 'xiaomi';
				} else {
					return 'other'
				}
			},
		}
	}
</script>

<style scoped>
	#root {
		/* flex-direction: column; */
		/* flex: 1; */
		overflow-x: hidden;
	}

	.multi--pc {
		background: url('../static/img/back-1.png');
		background-position: top 0px right, 100%;
		background-size: auto, 100% 100%;
		background-repeat: no-repeat, no-repeat;
	}

	.container--pc {
		min-width: 1200px;
		min-height: 745px;
		overflow: hidden;
		position: relative;
		flex: 1 1;
	}

	.container--Lascy {
		z-index: 1;
		display: flex;
		align-items: center;
		flex-wrap: nowrap;
		justify-content: space-between;
		box-sizing: border-box;
		padding: 0 32px;
		height: 60px;
		letter-spacing: 0;
		margin-top: 30px;
	}

	.logo--pc.dark--pc {
		background-image: url('../static/img/logo.png');
		background-repeat: no-repeat;
	}

	.link {
		font-size: 16px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 22px;
	}

	.logo--pc,
	.logo--pc:hover {
		webkit-transition: .5s;
		transition: .5s;
	}

	.logo--pc {
		width: 88px;
		height: 40px;
		margin-left: 200px;
		-webkit-transform: rotate(0deg);
		transform: rotate(0deg);
	}

	.line-active {
		width: 30px;
		height: 3px;
		background-color: #fff;
		margin: 0 auto;
		margin-top: 6px;
	}

	.line {
		width: 30px;
		height: 3px;
		background-color: #fff;
		margin: 0 auto;
		margin-top: 6px;
		opacity: 0;
	}

	a {
		background-color: initial;
		color: inherit;
		text-decoration: none;
	}

	.tabs--pc {
		display: flex;
		align-items: center;
		flex-wrap: nowrap;
	}

	.link--pc .dark--pc {
		color: #fff;
		font-weight: bold;
	}

	.multi--pc-none {
		background-color: #F3F4F5;
	}

	.multi--pc-none .link {
		color: #000 !important;
	}

	.multi--pc-none .line-active {
		background-color: #000 !important;
	}

	.link--pc {
		margin-right: 50px;
		text-decoration: none;
		font-size: 16px;
		line-height: 20px;
		cursor: pointer;
	}

	.title--1 {
		font-size: 50px;
		font-weight: bold;
		color: #fff;
		width: 100%;
		text-align: center;
		letter-spacing: 4px;
		margin-top: 20px;
	}

	.downloads--pc {
		position: absolute;
		margin-top: 30px;
		left: 42%;
	}

	.link--pc:last-child {
		margin-right: 250px;
	}

	.downloadButton--pc {
		display: inline-block;
		margin-right: 20px;
		padding: 5px 0 5px 5px;
		width: 130px;
		border-radius: 22px;
		background: #fff;
		color: #484848;
		line-height: 30px;
		vertical-align: bottom;
		text-decoration: none;
		font-size: 16px;
		font-family: PingFangSC-Regular, STHeiti, Microsoft YaHei, "\5FAE\8F6F\96C5\9ED1", serif;
		cursor: pointer;
	}

	.downloadContent--pc {
		display: flex;
		flex-wrap: nowrap;
		height: 30px;
	}

	.appleIcon--pc {
		margin: 2px 9px 2px 4px;
		width: 21px;
		height: 26px;
	}

	.downloadText--pc {
		text-align: center;
		font-weight: 600;
		line-height: 30px;
		letter-spacing: 1px;
		color: #484848;
	}

	.bg--1,
	.bg--2,
	.bg--3 {
		width: 100vw;
		text-align: center;
	}

	.title--2 {
		font-size: 58px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #222222;
		line-height: 81px;
		width: 100%;
		text-align: center;
		margin-top: 30px;
	}

	.bg--3 {
		margin-top: 30px;
	}

	.bg--4 {
		position: absolute;
		margin-top: -160px;
		z-index: -5;
	}

	.ct-box {
		width: 50vw;
		float: left;
	}

	.logo-3 {
		margin-left: 40%;
		height: 56px;
	}

	.logo-3 img {
		width: 56px;
		height: 56px;
	}

	.title--3 {
		line-height: 40px;
		padding-left: 10px;
		position: absolute;
		font-size: 40px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #222222;
		line-height: 56px;
	}

	.title--4 {
		margin-left: 40%;
		margin-top: 30px;
		font-size: 80px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #222222;
		line-height: 106px;
	}

	.title--5 {
		margin-left: 40%;
		margin-top: 10px;
		font-size: 80px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		line-height: 106px;
		color: #0081FF;
	}

	.title--6 {
		margin-left: 40%;
		font-weight: 400;
		color: rgba(34, 34, 34, 0.5);
		line-height: 45px;
		font-size: 32px;
	}

	.downloads-bottom {
		position: absolute;
		margin-top: 30px;
		left: 25%;
	}

	.downloads-bottom .downloadContent--pc {
		height: 38px;
		box-shadow: 0px 8px 16px 0px rgba(80, 126, 255, 0.38);
		border-radius: 19px;
	}

	.downloads-bottom .downloadContent--pc .appleIcon--pc {
		margin: 4px 11px 2px 9px;
	}

	.downloads-bottom .downloadContent--pc .downloadText--pc {
		line-height: 38px;
	}

	/* h5 */
	.page {
		display: grid;
		-ms-flex-direction: column;
		flex-direction: column;
		width: 100%;
		background: #fff;
	}

	.container--index-h5 {
		background: url('../static/img/back-1.png');
		background-position: top 0px right, 100%;
		background-size: auto, 100% 100%;
		background-repeat: no-repeat, no-repeat;
	}

	.container--header {
		z-index: 1;
		display: flex;
		align-items: center;
		flex-wrap: nowrap;
		justify-content: space-between;
		box-sizing: border-box;
		padding: 0 32px;
		height: 60px;
		letter-spacing: 0;
		margin-top: 30px;
	}

	.container--header-h5 .link-d-h5 {
		color: #222222 !important;
	}

	.container--header-h5 .line-active {
		color: #222222 !important;
	}

	.logo--h5 {
		background-image: url('../static/img/logo.png');
		background-repeat: no-repeat;
		width: 88px;
		height: 40px;
		-webkit-transform: rotate(0deg);
		transform: rotate(0deg);
	}

	.tabs--h5 {
		display: flex;
		align-items: center;
		flex-wrap: nowrap;
	}

	.link--h5.dark--h5 {
		color: #fff;
		font-weight: bold;
	}

	.link--h5 {
		margin-right: 10px;
		text-decoration: none;
		font-size: 16px;
		line-height: 20px;
		cursor: pointer;
	}

	.title--1-h5 {
		font-size: 30px;
	}

	.downloadButton--h5 {
		display: inline-block;
		margin-right: 20px;
		padding: 5px 0 5px 5px;
		width: 109px;
		border-radius: 22px;
		background: #fff;
		color: #484848;
		line-height: 30px;
		vertical-align: bottom;
		text-decoration: none;
		font-size: 14px;
		font-family: PingFangSC-Regular, STHeiti, Microsoft YaHei, "\5FAE\8F6F\96C5\9ED1", serif;
		cursor: pointer;
	}

	.downloads--h5 {
		position: absolute;
		margin-top: 30px;
		left: 20%;
	}

	.title--2-h5 {
		font-size: 24px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #222222;
		line-height: 81px;
		width: 100%;
		text-align: center;
		margin-top: 30px;
	}

	.bg--4-h5 {
		margin-top: 200px;
	}

	.logo-3-h5 {
		margin-left: 15%;
		height: 30px;
	}

	.title--3-h5 {
		font-size: 20px;
		line-height: 36px;
	}

	.title--4-h5 {
		line-height: 100px;
		margin-top: 0;
	}

	.title--5-h5 {
		margin-top: -55px;
	}

	.title--4-h5,
	.title--5-h5 {
		font-size: 24px;
		margin-left: 15%;
	}

	.title--6-h5 {
		margin-left: 15%;
		font-size: 16px;
		margin-top: -40px;
	}

	.bottom {
		text-align: center;
		margin-top: 30px;
	}

	.bottom a {
		font-size: 14px;
		color: #fff;
	}

	.bottom .cell {
		margin-left: 10px;
		margin-right: 10px;
	}

	.bottom-h5 {
		text-align: center;
		margin-top: -30px;
	}

	.bottom-h5 a {
		font-size: 10px;
		color: #fff;
	}

	.team-box {
		width: 100%;
		margin-top: 40px;
	}

	.team-title {
		font-size: 68px;
		font-weight: 600;
		color: #0081FF;
		line-height: 95px;
		margin-left: 15%;
	}

	.team-title-en {
		font-size: 30px;
		font-weight: 400;
		color: rgba(34, 34, 34, 0.5);
		line-height: 42px;
		margin-left: 15%;
	}

	.team-icon {
		float: right;
		margin-top: -185px;
		margin-right: 15%;
	}

	.team-list {
		width: 70%;
		margin-left: 15%;
		margin-top: 30px;
	}

	.item-info {
		width: 100%;
		background-color: #fff;
	}

	.item-info img {
		width: 100%;
	}

	.position {
		width: 100%;
		text-align: center;
		font-size: 24px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #222222;
		line-height: 33px;
		margin-top: 20px;
	}

	.team-line {
		width: 30px;
		height: 5px;
		background-color: #222222;
		margin: 0 auto;
		margin-top: 30px;
	}

	.item-info-box {
		width: 80%;
		margin-left: 10%;
		background-color: #F3F4F5;
		min-height: 140px;
		margin-top: 30px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(34, 34, 34, 0.58);
		border-radius: 10px;
	}

	.item-info-box div {
		padding-left: 20px;
		padding-right: 20px;
	}

	.item-info-box .name {
		padding-top: 20px;
	}

	.item-info-box .chat {
		padding-bottom: 20px;
	}
</style>
